import { authQueries, UseQueryOptionsObject } from 'src/api/queries/queries';
import { defaultOptions } from 'src/api/queries/queries.utils';
import { useMakeQuery } from 'src/api/queries/useMakeQuery';
import { profileClient, ProfileResponse } from 'src/lib/services/api/profile-api';

const useProfileQuery = (options?: UseQueryOptionsObject<ProfileResponse>) => {
  return useMakeQuery<ProfileResponse>([authQueries.profile], () => {
    return profileClient.get().then(response => {
      return response;
    });
  }, {
    staleTime: 10 * 1000,
    // Largely informational for this static query key — same-key refetches
    // already preserve data in React Query v4. Kept as explicit intent so
    // useSubscriptionPlan (line 164) can rely on activePlanSlug surviving a
    // refetch and avoid the Monthly Video Count flicker on Brand Profile.
    keepPreviousData: true,
    ...defaultOptions({
      auth: true,
      ...(options ?? {}),
      retry: (failureCount) => {
        return failureCount < 3;
      },
    }),
  });
};

export { useProfileQuery };
